var ReactRailsUJS = require("react_ujs")
var componentRequireContext = require.context("components", true)
ReactRailsUJS.useContext(componentRequireContext)
export { ReactRailsUJS }
